// 使用通用布局的路由配置

export default [
  {
    name: "order",
    redirect: "order",
    meta: { title: "订单管理", icon: "view_list" },
    children: [
      {
        name: "order",
        component: () => import("@/views/Order/index"),
        meta: { title: "订单列表" },
      },
      {
        name: "refund",
        component: () => import("@/views/Order/refund"),
        meta: { title: "退款单管理" },
      },
      {
        name: "return",
        component: () => import("@/views/Order/return"),
        meta: { title: "退货单管理" },
      },
    ],
  },
  {
    name: "product",
    redirect: "product",
    meta: { title: "商品管理", icon: "view_module" },
    children: [
      {
        name: "product",
        component: () => import("@/views/Product/Product/index"),
        meta: { title: "商品列表" },
      },
      {
        name: "category",
        component: () => import("@/views/Product/category"),
        meta: { title: "商品分类" },
      },
      {
        name: "edit",
        params: ["id"],
        component: () => import("@/views/Product/Product/edit"),
        meta: { title: "商品编辑" },
        hidden: true,
      },
    ],
  },
  {
    name: "activity",
    redirect: "/activity/activity",
    meta: { title: "内购管理", icon: "event" },
    children: [
      {
        name: "activity",
        component: () => import("@/views/Activity/index"),
        meta: { title: "活动列表" },
        noShowingChildren: true,
        children: [
          {
            name: "pagesetting",
            component: () => import("@/views/Activity/PageSetting/index"),
            redirect: "noredirect",
            meta: { title: "页面设置" },
            hidden: true,
            children: [
              {
                name: "home-show",
                component: () =>
                  import("@/views/Activity/PageSetting/home-show"),
                meta: { title: "首页显示设置" },
                hidden: true,
              },
              {
                name: "carousel-list",
                component: () =>
                  import("@/views/Activity/PageSetting/carousel-list"),
                meta: { title: "轮播图" },
                hidden: true,
              },
              {
                name: "carousel-create",
                component: () =>
                  import("@/views/Activity/PageSetting/carousel-form"),
                meta: { title: "添加轮播图" },
                hidden: true,
              },
              {
                name: "carousel-edit",
                params: ["id"],
                component: () =>
                  import("@/views/Activity/PageSetting/carousel-form"),
                meta: { title: "编辑轮播图" },
                hidden: true,
              },
              {
                name: "flagship",
                component: () =>
                  import("@/views/Activity/PageSetting/flagship"),
                meta: { title: "本月主打" },
                hidden: true,
              },
              {
                name: "recommend",
                component: () =>
                  import("@/views/Activity/PageSetting/recommend"),
                meta: { title: "商品推荐" },
                hidden: true,
              },
            ],
          },
        ],
      },
      {
        name: "activity-create",
        component: () => import("@/views/Activity/form"),
        meta: { title: "创建内购活动" },
        hidden: true,
      },
      {
        name: "activity-edit",
        params: ["id"],
        component: () => import("@/views/Activity/form"),
        meta: { title: "编辑内购活动" },
        hidden: true,
      },
      {
        name: "activity-product",
        params: ["id"],
        component: () => import("@/views/Activity/product"),
        meta: { title: "内购商品清单" },
        hidden: true,
      },
      {
        name: "activity-discount",
        params: ["id", "activityName"],
        component: () => import("@/views/Activity/Promotion/discount"),
        meta: { title: "折扣设置" },
        hidden: true,
      },
    ],
  },
  {
    name: "company",
    redirect: "company",
    meta: { title: "公司管理", icon: "business_center" },
    children: [
      {
        name: "company",
        component: () => import("@/views/Company/index"),
        meta: { title: "公司列表" },
      },
      {
        name: "company-create",
        component: () => import("@/views/Company/form"),
        meta: { title: "创建公司" },
        hidden: true,
      },
      {
        name: "company-edit",
        params: ["id"],
        component: () => import("@/views/Company/form"),
        meta: { title: "编辑公司" },
        hidden: true,
      },
      {
        name: "company-staff",
        params: ["id"],
        component: () => import("@/views/Company/staff"),
        meta: { title: "员工管理" },
        hidden: true,
      },
    ],
  },
  {
    name: "report",
    redirect: "order",
    meta: { title: "报表统计", icon: "receipt" },
    children: [
      {
        name: "order",
        component: () => import("@/views/Report/order"),
        meta: { title: "订单报表" },
      },
    ],
  },
];
